/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ID контакта.
 */
export interface ContactLoyaltyView { 
    /**
     * Адрес контакта.
     */
    address?: string;
    /**
     * Контактное лицо.
     */
    contactName?: string;
    /**
     * Номер телефона контакта.
     */
    contactPhone?: string;
    /**
     * Email контакта.
     */
    contactEmail?: string;
    /**
     * веб-сайт.
     */
    website: string;
    /**
     * ID котакта.
     */
    id: string;
}

